// extracted by mini-css-extract-plugin
export default {"main":"BradCrumbsMobile_main__F7wwJ"};